import { Navigate } from "react-router-dom";
import { useUserStore } from "entities/user";
import { JSX } from "react";

type Props = {
    children: JSX.Element;
    redirectTo?: string; // по умолчанию "/"
};

export const AuthRedirect = ({ children, redirectTo = "/" }: Props) => {
    const userInfo = useUserStore(state => state.userInfo);
    const isAuth = Boolean(userInfo?.id);

    if (isAuth) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};
